import {useIsRealUserModeEnabled} from '@aboutyou/data-fetcher';
import {lazy} from '@aboutyou/lazy-imports';
import {FooterSkeleton} from '@aboutyou/logic-components';
import {useInView} from '@aboutyou/ui-components';
import React, {FC, memo} from 'react';

const LazyFooterDynamicADP = lazy(
  () =>
    import('@aboutyou/logic-components').then(mod => ({
      default: mod.FooterDynamicADP,
    })),
  {fallback: <FooterSkeleton />},
);

const FooterConfigured: FC = memo(function Footer() {
  return <LazyFooterDynamicADP hideCategories={false} />;
});

export const FooterDynamicADP = () => {
  const isRealUserModeEnabled = useIsRealUserModeEnabled();
  const {ref, inView} = useInView<HTMLDivElement>({
    threshold: 0,
    rootMargin: '500px',
    triggerOnce: true,
  });

  if (!isRealUserModeEnabled) {
    // if real user mode is not activated, always render the footer on the server
    return <FooterConfigured />;
  }

  return inView ? <FooterConfigured /> : <FooterSkeleton ref={ref} />;
};
